import dayjs from 'dayjs';
import { isEmpty } from 'lodash-es';
import { i18next } from '@frontend/i18n';
import { Location } from '@frontend/location-helpers';
import { TagType } from '@frontend/design-system';

export const getTimeIn12HrFormat = (date: string, time: string) => {
  return dayjs(`${date} ${time}`).format('h:mmA');
};

export const isEndTimeBeforeStartTime = (timeRange?: string[]) => {
  if (!isEmpty(timeRange)) {
    const [start, end] = timeRange || [];
    const startTime = dayjs(start, 'HH:mm');
    const endTime = dayjs(end, 'HH:mm');
    return endTime.isBefore(startTime);
  }
  return false;
};

export const defaultTemplate = i18next.t(
  'Hello, {first_name}, this is {practice_name}. We have a last minute opening for {date_time}. Does this time work for you? Reply yes or no.',
  { ns: 'schedule-quick-fill' }
);

export const getTemplateTags = (locationDetails: Location, dateAndTime: string): TagType[] => {
  return [
    {
      label: i18next.t('First Name', { ns: 'schedule-quick-fill' }),
      key: '{first_name}',
      value: '',
    },
    {
      label: i18next.t('Preferred Name', { ns: 'schedule-quick-fill' }),
      key: '{preferred_name}',
      value: '',
    },
    {
      label: i18next.t('Practice Name', { ns: 'schedule-quick-fill' }),
      key: ['{practice_name}', '{company_name}'],
      value: locationDetails?.Name ?? '',
    },
    {
      label: i18next.t('Practice Phone', { ns: 'schedule-quick-fill' }),
      key: '{practice_phone}',
      value: locationDetails?.PhoneNumber ?? '',
    },
    {
      label: i18next.t('Date & Time', { ns: 'schedule-quick-fill' }),
      key: '{date_time}',
      value: dateAndTime ?? '',
      readOnly: true,
    },
  ];
};
